export async function login(email: string, password: string) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute('content')

  const res = await fetch('/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken || '',
    },
    credentials: 'include', // important: sends the session cookie
    body: JSON.stringify({ email, password }),
  })

  return res.json()
}

export async function logout() {
  const csrfToken = document
    .querySelector('meta[name="csrf-token"]')
    ?.getAttribute('content')

  const res = await fetch('/logout', {
    method: 'DELETE',
    headers: {
      'X-CSRF-Token': csrfToken || '',
    },
    credentials: 'include',
  })

  // Logout should never crash the app
  if (res.headers.get('content-type')?.includes('application/json')) {
    return res.json()
  }
}
